
import React, { useState } from 'react'
import { Link, useLocation } from "react-router-dom"
import { Accordion, Card, Button } from "react-bootstrap";
import "./Sidebar.css"

function Sidebar({ sidebarItems }) {
  const location = useLocation();

  // store which dropdown is open (by index or path)
  const [openIndex, setOpenIndex] = useState(null);

  const pathParts = location.pathname.split("/"); // Split path into parts

  return (
    <div className="sidebar_container">
      {/* <div className="logo_container">
        <img src={logo} alt="" className='w-50' />
      </div> */}
      <div className="link_container">
        <ul className="p-0 m-0">
          {sidebarItems && sidebarItems.map((item, index) => {

            const isOpen = openIndex === index; // check if this dropdown is open

            return (
              item.subTabs ? (
                <div className="d-flex flex-column text-white p-2" key={index}>
                  <Button
                    className="nav_item border-0"
                    onClick={() =>
                      setOpenIndex(isOpen ? null : index) // toggle only this one
                    }
                  >
                    <p className="mb-0 pe-4">{item.name}</p>
                    {isOpen ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor"
                        className="bi bi-chevron-up" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 
                          5.647a.5.5 0 0 1-.708-.708z" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor"
                        className="bi bi-chevron-down" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 
                          .708 0L8 10.293l5.646-5.647a.5.5 
                          0 0 1 .708.708l-6 6a.5.5 0 0 
                          1-.708 0l-6-6a.5.5 0 0 1 
                          0-.708" />
                      </svg>
                    )}
                  </Button>

                  {isOpen && (
                    <Accordion defaultActiveKey="0" className="w-100">
                      <Card className="bg-transparent border-0">
                        <Accordion.Collapse eventKey="0">
                          <div className="d-flex flex-column ps-3">
                            {item.subTabs.map((tabitem, subIndex) => (
                              <div
                                key={subIndex}
                                className={
                                  pathParts[3] &&
                                  pathParts[3].toLowerCase().includes(
                                    tabitem.path.toLowerCase().split("/")[1]
                                  )
                                    ? "active menue_nav_item"
                                    : "menue_nav_item"
                                }
                              >
                                <Link
                                  className="text-start border-0"
                                  to={`/dashboard/${
                                    tabitem.path ? tabitem.path : tabitem.name.toLowerCase()
                                  }`}
                                >
                                  ● {tabitem.name}
                                </Link>
                              </div>
                            ))}
                          </div>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                  )}
                </div>
              ) : item.path === "tarteeb" ? (
                <li
                  key={index}
                  className={
                    pathParts[2]
                      ? pathParts[2].toLowerCase().includes(item.path.toLowerCase())
                        ? "nav_item active"
                        : "nav_item"
                      : pathParts[1].toLowerCase().includes(item.path.toLowerCase())
                      ? "nav_item active"
                      : "nav_item"
                  }
                >
                  <a href="https://taarteb.com/" target="_blank" rel="noopener noreferrer">
                    <span className="mx-2">{item.name}</span>
                  </a>
                </li>
              ) : (
                <li
                  key={index}
                  className={
                    // location.pathname.toLowerCase() === `/dashboard/${item.path.toLowerCase()}`
                    location.pathname.toLowerCase().includes(`/dashboard/${item.path.toLowerCase()}`)
                      ? "nav_item active"
                      : "nav_item"
                  }
                >
                  <Link to={`/dashboard/${item.path ? item.path : item.name.toLowerCase()}`}>
                    <span className="mx-2">{item.name}</span>
                  </Link>
                </li>
              )
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default Sidebar
